/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasty_Light_Shark_FearInputs */

const fr_tasty_light_shark_fear = /** @type {(inputs: Tasty_Light_Shark_FearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéro de téléphone`)
};

/**

* @param {Tasty_Light_Shark_FearInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tasty_light_shark_fear = /** @type {((inputs?: Tasty_Light_Shark_FearInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasty_Light_Shark_FearInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tasty_light_shark_fear(inputs)
});